import { Outlet } from "react-router-dom";
import StudentHeader from "./StudentHeader";
import StudentSidebar from "./StudentSidebar";

export default function StudentLayout() {
  return (
    <div style={{ display: "flex", minHeight: "100vh", direction: "rtl" }}>
      <StudentSidebar />

      <div style={{ flex: 1 }}>
        <StudentHeader />
        <div style={{ padding: 20 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
